import React, { useEffect, useState } from "react";
import { TextField, Typography, Button, FormHelperText } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import {
  sendMobileNoAPICall,
  locationCheckAPICall,
  AdminLoginToClientAccountAPICall,
  reSendMobileOTPAPICall,
  validateMobileOTPAPICall,
  SaveIpAddressAPICall,
} from "../shared/APICalls";
import {
  IAdminLogin,
  IMobile,
  IMobileOtpValidation,
  IReSendMobileOTP,
  ISaveIPaddress,
} from "../shared/dtos";
import routesData from "../shared/routes.json";
import SignupStyles from "../pages/Styles/SignUp.module.scss";
import SnackBar from "../Components/SnackBars/SnackBar";
import Checkboxempty from "../Components/assets/Images/Checkboxempty.svg";
import Checkboxdone from "../Components/assets/Images/Checkbox_blue.svg";
import TagManager from "react-gtm-module";
import { TransitionProps } from "@mui/material/transitions";
import SucessSnackBar from "../Components/SnackBars/SucesssnackBar";
import LeftComp from "../Components/LeftComp/LeftComp";

import fstlogo from "../Components/assets/Images/fstlogo.svg";
import GooglePlayStore from "../Components/assets/Images/GooglePlayStore.svg";
import AppStore from "../Components/assets/Images/AppStore.svg";
import MicroSoft from "../Components/assets/Images/MicrosoftStore.svg";
import leftcompimage from "../Components/assets/Images/SignupIllustration.svg";

const dots = ["1", "2", "3", "4", "5", "6"];

export default function Onboarding() {
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());

  const token = params.token;
  const nextStage = params.next_stage;
  const navigationData = routesData;

  useEffect(() => {
    if (token) {
      sessionStorage.setItem("access-token", token);
      setTimeout(() => {
        if (nextStage && navigationData.hasOwnProperty(nextStage)) {
          navigate(navigationData[nextStage]);
        }
      }, 300);
    }
  }, [params]);

  //   console.log("params", params);

  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  const [mode, setMode] = useState(getSystemTheme());

  useEffect(() => {
    setMode(getSystemTheme());
  }, [getSystemTheme]);

  return (
    <>
      <div className={SignupStyles.layout}>
        <div className={SignupStyles.sidebar}>
          <LeftComp />
        </div>
        <div className={SignupStyles.pageContent}>
          <div className={SignupStyles.wrapper}>
            <div className={SignupStyles.RightContainer}>
              <div className={SignupStyles.contentSection}>
                <div className={SignupStyles.headerSection}>
                  <img
                    src={fstlogo}
                    alt=""
                    className={SignupStyles.fstlogo}
                    // style={{
                    //   filter:
                    //     mode === "dark"
                    //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                    //       : "",
                    // }}
                  />
                  <p className={SignupStyles.signup}>Welcome to Firstock</p>
                  <p className={SignupStyles.subText}>
                    Sign in, or open a new account
                  </p>
                </div>

                <div className={SignupStyles.imageContainer}>
                  <img
                    src={leftcompimage}
                    alt=""
                    className={SignupStyles.centerImage}
                  />
                </div>
              </div>
            </div>
            <div className={SignupStyles.firstockApps}>
              <div className={SignupStyles.apps}>
                <a
                  href="https://play.google.com/store/apps/details?id=in.firstock.mobile"
                  target="_blank"
                >
                  <img
                    src={GooglePlayStore}
                    className={SignupStyles.Googlestoreimage}
                  />
                </a>

                <a
                  href="https://apps.apple.com/us/app/firstock-trade-invest/id6746480444"
                  target="_blank"
                >
                  <img src={AppStore} className={SignupStyles.Appstoreimage} />
                </a>

                <a href="https://firstock-common.s3.ap-south-1.amazonaws.com/app/Firstock_INV_Live_Firstock_2023.7.4-setup.zip">
                  <img
                    src={MicroSoft}
                    className={SignupStyles.Microstoreimage}
                  />
                </a>
              </div>
              <div className={SignupStyles.description}>
                <div className={SignupStyles.text1}>
                  Firstock Broking (P) Ltd: NSE & BSE - SEBI
                </div>
                <div className={SignupStyles.text1}>
                  Registration No. INZ000260334 | CDSL - SEBI Registration No :
                  IN-
                </div>
                <div className={SignupStyles.text1}>
                  DP-67-2015 | Mutual Fund ARN: 132812 | Smart Online Dispute
                  Resolution | SEBI SCORES
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
